import FieldConfig from "../../../proto/field-config";
import FieldProgress from "../../../generic/progress/progress";
import Task from "../../../../model2/task/task";
import FieldProjectProgressItems_TableCell from "./render/table/table-cell";

export default class FieldProjectProgressItems extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel  = "Progress items"
        this.label      = "Progress items"

        this.renderComponents.tableCell             = FieldProjectProgressItems_TableCell
        this.renderComponents.tableCellCalculated   = FieldProjectProgressItems_TableCell
    }

    canEdit(model:Task):boolean {
        return false
    }
}
